import './add-user-modal.scss';
import { useForm } from 'react-hook-form';
import Toast from '../../shared/Toast/Toast';
import { useTranslation } from 'react-i18next';
import { useCloseOldModal } from '../../../store/modal/modalHooks';
import {
  useCompanyManagementCompanies,
  useCompanyManagementSetCompanyUsers,
  useUserManagementAddNewUser,
} from '../../../store/CompanyManagement/companyManagementHooks';
import { Button, Form, ModalFooter, ModalHeader } from 'reactstrap';
import { useFetchProfile, useProfile } from '../../../store/Auth/authHooks';
import { GeneralInformation } from '../../pages/user-management/GeneralInformation/GeneralInformation';
import { useEffect } from 'react';

const AddUserModal = () => {
  const profile = useProfile();
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();
  const createUser = useUserManagementAddNewUser();
  const fetchProfile = useFetchProfile();
  const companies = useCompanyManagementCompanies();
  const fetchCompanyUsers = useCompanyManagementSetCompanyUsers();

  const defaultValues = {
    fullName: '',
    email: '',
    job_title: '',
    company: profile.companyId,
    phone: '',
  };

  useEffect(() => {
    fetchProfile().finally();
  }, []);

  const form = useForm({ defaultValues });
  const {
    handleSubmit,
    formState: { errors },
  } = form;

  const getErrorMessage = (errorMessage?: any) => {
    switch (errorMessage) {
      case 'User with this email exist':
        return t('USER_WITH_MAIL_EXIST');
      case 'Password requirements not met.':
        return errorMessage;
    }
  };

  const onSubmit = (data: any) => {
    const company = companies.find((company) => company.id === data.company);
    const newData = {
      ...data,
      locationId: company?.locationId || -1,
      company_token: company?.token,
      company_id: company?.id,
    };

    createUser(newData)
      .then(() => {
        Toast(
          'success-request',
          t('ADD_USER_SUCCESS_MESSAGE', { email: data.email })
        );
        fetchCompanyUsers(profile.companyId!).finally();
      })
      .catch((error) => {
        Toast('error', getErrorMessage(error.response.data.error.message));
      })
      .finally(() => {
        closeModal();
      });
  };

  return (
    <div className="add-new-user-modal">
      <div className="form-modal">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            <p className="form-header-title">{t('CREATE_NEW_USER_TITLE')}</p>
          </ModalHeader>
          <>
            <GeneralInformation form={form} />
          </>
          <ModalFooter>
            <Button type="button" color="" onClick={closeModal}>
              {t('REMOVE_MODAL_CANCEL_BUTTON')}
            </Button>{' '}
            <Button type="submit" color="primary">
              {t('CREATE_BUTTON')}
            </Button>{' '}
          </ModalFooter>
        </Form>
      </div>
    </div>
  );
};

export default AddUserModal;
